import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Flex,
  Modal,
  Row,
  Skeleton,
  Space,
  Switch,
  Table,
  Tag,
  Transfer,
  message,
} from "antd";

import {
  GetProp,
  TableColumnsType,
  TableProps,
  TransferProps,
  Typography,
} from "antd";
import { BooleanParam, NumberParam, useQueryParams } from "use-query-params";
import Globais, {
  criarOuDeletarPeriodoUsuario,
  formatarData,
  validateDataCheckOutMaior,
  validateToken,
} from "../../components/Globais";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

type TransferItem = GetProp<TransferProps<RecordType>, "dataSource">[number];
type TableRowSelection<T extends object> = TableProps<T>["rowSelection"];

interface RecordType {
  key: string;
  periodo: string;
  dataEspecial: string;
}

interface DataType {
  key: string;
  periodo: string;
  dataEspecial: string;
}

interface TableTransferProps extends TransferProps<TransferItem> {
  dataSource: DataType[];
  leftColumns: TableColumnsType<DataType>;
  rightColumns: TableColumnsType<DataType>;
}

// Customize Table Transfer
const TableTransfer = ({
  leftColumns,
  rightColumns,
  ...restProps
}: TableTransferProps) => (
  <Transfer {...restProps}>
    {({
      direction,
      filteredItems,
      onItemSelect,
      onItemSelectAll,
      selectedKeys: listSelectedKeys,
      disabled: listDisabled,
    }) => {
      const columns = direction === "left" ? leftColumns : rightColumns;

      const rowSelection: TableRowSelection<TransferItem> = {
        getCheckboxProps: () => ({ disabled: listDisabled }),
        onChange(selectedRowKeys) {
          onItemSelectAll(selectedRowKeys, "replace");
        },
        selectedRowKeys: listSelectedKeys,
        selections: [
          Table.SELECTION_ALL,
          Table.SELECTION_INVERT,
          Table.SELECTION_NONE,
        ],
      };

      return (
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={filteredItems}
          size="small"
          style={{ pointerEvents: listDisabled ? "none" : undefined }}
          onRow={({ key }) => ({
            onClick: () => {
              onItemSelect(key, !listSelectedKeys.includes(key));
            },
          })}
        />
      );
    }}
  </Transfer>
);

// const mockTags = ["cat", "dog", "bird"];

const dados = [
  {
    key: "0",
    periodo: "07/04/2024 a 14/04/2024",
    dataEspecial: "Sexta-santa",
  },
  {
    key: "1",
    periodo: "14/04/2024 a 21/04/2024",
    dataEspecial: "Não",
  },
  {
    key: "2",
    periodo: "21/04/2024 a 28/04/2024",
    dataEspecial: "Sexta-santa",
  },
  {
    key: "3",
    periodo: "01/05/2024 a 08/05/2024",
    dataEspecial: "Não",
  },
  {
    key: "4",
    periodo: "08/05/2024 a 15/05/2024",
    dataEspecial: "Sexta-santa",
  },
  {
    key: "5",
    periodo: "100/05/2024 a 200/05/2024",
    dataEspecial: "Não",
  },
  {
    key: "6",
    periodo: "01/05/2025 a 08/05/2025",
    dataEspecial: "Não",
  },
  {
    key: "7",
    periodo: "08/05/2025 a 15/05/2025",
    dataEspecial: "Sexta-santa",
  },
  {
    key: "8",
    periodo: "15/05/2025 a 22/05/2025",
    dataEspecial: "Não",
  },
];

// const mockData: RecordType[] = Array.from({ length: 20 }).map((_, i) => ({
//   key: i.toString(),
//   periodo: `content${i + 1}`,
//   dataEspecial: `description of content${i + 1}`,
// }));

const columnsLeft: TableColumnsType<DataType> = [
  {
    dataIndex: "periodo",
    title: "Períodos disponíveis",
  },

  {
    dataIndex: "dataEspecial",
    title: "Data especial?",
  },
];
const columnsRight: TableColumnsType<DataType> = [
  {
    dataIndex: "periodo",
    title: "Período do proprietário",
  },

  {
    dataIndex: "dataEspecial",
    title: "Data especial?",
  },
];

export default function ViewAdicionarPeriodos() {
  const [targetKeys, setTargetKeys] = useState<TransferProps["targetKeys"]>([]);
  // const [targetKeys, setTargetKeys] = useState<any>();
  const [disabled, setDisabled] = useState(false);
  const [openAlterandoDivulgado, setOpenAlterandoDivulgado] = useState(false);
  const { Title } = Typography;
  const nomeEmpreend = useRef("");
  const waiting = useRef(false);

  const periodo = useRef("");
  const numeroApto = useRef("");
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(true);
  const [periodosData, setPeriodosData] = useState<any>();
  const periodosSelecionados = useRef([]);
  const [periodosUsuario, setPeriodosUsuario] = useState([{}]);
  const confirmadoAlteracaoPeriodoDivulgado = useRef(false);
  const prosseguir = useRef(true);

  const [nCotaUsuarioId, setNCotaUsuarioId] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });


  const mockData: RecordType[] = periodosData;
  const onChange: TableTransferProps["onChange"] = (nextTargetKeys) => {
    // console.log(nextTargetKeys);
    setTargetKeys(nextTargetKeys);
  };
  const hoje = new Date().toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };


 

  useEffect(() => {
    const fetch = async () => {
      const Token = validateToken();

      if (Token && nCotaUsuarioId.cotaUsuarioId) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/periodousuario/0/${nCotaUsuarioId.cotaUsuarioId}`;
        const URLDetalhesEmpreend = `${Globais.DOMINIOBACK}/cota-usuario/usuario/${Token.id}/${nCotaUsuarioId.cotaUsuarioId}`;

        try {
          const response = await axios.get(URL, {
            headers: { Authorization: Token.AuthStr },
          });
          const responseDetalhesEmpreend = await axios.get(
            URLDetalhesEmpreend,
            {
              headers: { Authorization: Token.AuthStr },
            }
          );

          if (response && responseDetalhesEmpreend) {
            const URLPeriodos = `${Globais.DOMINIOBACK}/periodo/cota/periodos/${responseDetalhesEmpreend.data.CotaTable.id}/${Token.id}`;

            try {
              const responsePeriodos = await axios.get(URLPeriodos, {
                headers: { Authorization: Token.AuthStr },
              });

              if (responsePeriodos) {
                let ArrayPeriodosUsuarios = [0];
                let ArrayPeriodos = [{}];
                responsePeriodos.data.map((p: any) => {
                  p.key = p.id;
                  if (
                    !validateDataCheckOutMaior(
                      formatarData(p.checkOut),
                      hoje
                    ) &&
                    p.fracionamento === 0
                  ) {
                    p.periodo = `${formatarData(p.checkIn)} a ${formatarData(
                      p.checkOut
                    )}`;
                    ArrayPeriodos.push({
                      key: p.id,
                      periodo: p.periodo,
                      dataEspecial: p.dataEspecial,
                    });
                  }
                });
                response.data.map(async (q: any) => {
                  q.key = q.id;

                  if (
                    q.active !== 0 &&
                    !validateDataCheckOutMaior(
                      formatarData(q.PeriodoTable.checkOut),
                      hoje
                    ) &&
                    q.fracionamento === 0 &&
                    q.concluido !== 2
                  ) {
                    let contadorReservado = 0;
                    response.data.map(async (z: any) => {
                      if (z.fracionamento === q.id) {
                        if (z.concluido === 2) {
                          contadorReservado++;
                        }
                      }
                    });
                    if (contadorReservado === 0) {
                      ArrayPeriodosUsuarios.push(q.PeriodoTable.id);
                    }
                  }
                });

                ArrayPeriodosUsuarios.shift();
                ArrayPeriodos.shift();
                setPeriodosData(ArrayPeriodos);
                setPeriodosUsuario(response.data);
                setTargetKeys(ArrayPeriodosUsuarios);
              }
            } catch (e) {
              console.log(e);
            }

            nomeEmpreend.current =
              responseDetalhesEmpreend.data.CotaTable.AptoTable.EmpreendimentoTable.nome;
            numeroApto.current = responseDetalhesEmpreend.data.numeroApto;

            setIsLoading(false);
          }
        } catch (error) {
          error("Há algo de errado.");
        }
      }
    };
    fetch();
  }, []);

  const adicionarPeriodos = async (confirmado: boolean) => {
    let incluir = [0];
    let retirar = [0];
    let retirarDivulgado = [0];

    let contadorPeriodoUsuario = 0;
    let contadorTargetKey = 0;

    //rotina para ver quais períodos vão ser criados periodos usuarios.
    targetKeys?.map((p: any) => {
      let contadorIncluir = 0;
      periodosUsuario.map((PEU: any) => {
        if (p === PEU.PeriodoTable.id) {
          contadorIncluir++;
        }
      });
      if (contadorIncluir === 0) {
        incluir.push(p);
      }
      contadorTargetKey++;
    });
    //rotina para ver quais períodos serão retirados.

    const tratamentoPeriodosDivulgados = (PEU: any) =>{
      waiting.current = true;
      if (confirmadoAlteracaoPeriodoDivulgado.current) {
        waiting.current = false;
        retirarDivulgado.push(PEU.PeriodoTable.id);
      } else {
        periodo.current = `${formatarData(
          PEU.PeriodoTable.checkIn
        )} a ${formatarData(PEU.PeriodoTable.checkOut)}`;
        setOpenAlterandoDivulgado(true);
      }

    }

    periodosUsuario.map((PEU: any) => {
      let contadorExcluir = 0;
      let contadorDivulgado = 0;
      if(PEU.fracionamento === 0){
        targetKeys?.map((p: any) => {
          if (p === PEU.PeriodoTable.id) {
            contadorExcluir++;
          }
        });
  
        if (contadorExcluir === 0) {
          if (PEU.divulgado === 1) {
            tratamentoPeriodosDivulgados(PEU);
           
          } else {
            periodosUsuario.map((PEU2: any)=>{
              if(PEU.id === PEU2.fracionamento){
                contadorDivulgado++;
              }
            });
            if(contadorDivulgado === 0){
              retirar.push(PEU.PeriodoTable.id);
            }else{
            tratamentoPeriodosDivulgados(PEU);
            }
            
          }
        }
        

      }
      contadorPeriodoUsuario++;
     
    });
    incluir.shift();
    retirar.shift();
    retirarDivulgado.shift();
    



    if (
      periodosUsuario.length === contadorPeriodoUsuario &&
      targetKeys?.length === contadorTargetKey &&
      !waiting.current
    ) {
      
      if (incluir.length !== 0) {
        incluir.map(async (i: any) => {
          let formDataIncluir = {
            periodoId: i,
            cotasUsuariosId: nCotaUsuarioId.cotaUsuarioId,
          };
          const result = criarOuDeletarPeriodoUsuario(formDataIncluir, "CRIAR");

          if ((await result) === 2) {
            error("Alguns periodos não foram incluídos");
          }
        });
      }
      if (retirar.length !== 0) {
        retirar.map(async (r: any) => {
          let periodoUsuarioId = 0;
          periodosUsuario.map((PEU: any) => {
            if (r === PEU.PeriodoTable.id) {
              periodoUsuarioId = PEU.id;
            }
          });
          if (periodoUsuarioId !== 0) {
            let formDataDeletar = {
              id: periodoUsuarioId,
            };
            const result = criarOuDeletarPeriodoUsuario(
              formDataDeletar,
              "DELETAR"
            );

            if ((await result) === 2) {
              error("Alguns periodos não foram retirados.");
            }
          } else {
            error("Alguns periodos não foram retirados.");
          }
        });
      }
      if (retirarDivulgado.length !== 0) {
        let periodoUsuarioId1Fracao = 0;
        let periodoUsuarioId2Fracao = 0;
        let temFracao = false;

        retirarDivulgado.map(async (rd: any) => {
          let periodoUsuarioId = 0;
          periodosUsuario.map((PEU: any) => {
            if (rd === PEU.PeriodoTable.id) {
              periodoUsuarioId = PEU.id;
              periodosUsuario.map((PEU2: any)=>{
                if(PEU.id === PEU2.fracionamento){
                  temFracao = true;
                  if(periodoUsuarioId1Fracao === 0){
                    periodoUsuarioId1Fracao = PEU2.id;
                  }else{
                    periodoUsuarioId2Fracao = PEU2.id;
                  }


                }

              })
            }
          });
          if (periodoUsuarioId !== 0) {
            if(temFracao){
              let formDataAtualizar1Fracao = {
                id: periodoUsuarioId1Fracao,
                status: "ALTERANDO",
                active: 4,
              };
              let formDataAtualizar2Fracao = {
                id: periodoUsuarioId2Fracao,
                status: "ALTERANDO",
                active: 4,
              };
              const result1Fracao = criarOuDeletarPeriodoUsuario(
                formDataAtualizar1Fracao,
                "DELETAR_DIVULGADO"
              );
              if(await result1Fracao){
                const result12Fracao = criarOuDeletarPeriodoUsuario(
                  formDataAtualizar2Fracao,
                  "DELETAR_DIVULGADO"
                );
              }
            }
            let formDataAtualizar = {
              id: periodoUsuarioId,
              status: "ALTERANDO",
              active: 4,
            };
            const result = criarOuDeletarPeriodoUsuario(
              formDataAtualizar,
              "DELETAR_DIVULGADO"
            );
         

            if ((await result) === 2) {
              error("Alguns periodos não foram retirados.");
            }
          } else {
            error("Alguns periodos não foram retirados.");
          }
        });
      }
      if (!waiting.current) {
        setOpenAlterandoDivulgado(false);
        success("Período(s) atualizados(s)com sucesso!");

        setTimeout(() => {
          document.location.href = `/disponibilizacaoPeriodos/?cotaUsuarioId=${nCotaUsuarioId.cotaUsuarioId}&&ncota=0&&empreend=${nomeEmpreend.current}`;
        }, 2000);
      }
    }
  };

  return (
    <>
      {" "}
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Flex
          gap="large"
          align="center"
          justify="center"
          vertical
          style={{
            width: "100%",
            height: "100%",
            padding: "20",
            overflow: "scroll",
          }}
        >
          {contextHolder}
          <Modal
            title="Período divulgado, deseja continuar com a alteração?"
            open={openAlterandoDivulgado}
            onOk={() => {
              confirmadoAlteracaoPeriodoDivulgado.current = true;
              adicionarPeriodos(true);
            }}
            onCancel={() => {
              setOpenAlterandoDivulgado(false);
              // document.location.reload();
            }}
            okText="Sim, quero continuar"
            cancelText="Não"
          >
            <p>
              Caso algum dos períodos retirados da coluna "Períodos do
              proprietário" esteja sendo anunciado, a alteração não será
              refletida automaticamente. Caso continue, nossa equipe responsável
              fará as devidas alterações nos anúncios correspondentes e então
              você receberá um e-mail com a confirmação. Até lá, as
              configurações anteriores continuam sendo válidas.
            </p>
          </Modal>

          <Row style={{ width: "100%" }}>
            {/* {contextHolder} */}
            <Row style={{ width: "100%" }}>
              <Col span={3}>
                <Flex align="center" justify="center" style={{ marginTop: 20 }}>
                  <a
                    href={`/disponibilizacaoPeriodos/?cotaUsuarioId=${nCotaUsuarioId.cotaUsuarioId}&&ncota=0&&empreend=${nomeEmpreend.current}`}
                  >
                    <ArrowBackIcon color="primary" />
                  </a>
                </Flex>
              </Col>
              <Col span={18}>
                {nomeEmpreend.current && numeroApto.current ? (
                  <>
                    <Flex
                      align="center"
                      justify="center"
                      style={{ width: "100%" }}
                    >
                      <Col span={8}>
                        <Flex align="center" justify="end">
                          <CalendarMonthIcon color="primary" fontSize="large" />
                        </Flex>
                      </Col>
                      <Col span={16}>
                        <Flex
                          align="center"
                          justify="start"
                          style={{ marginLeft: 10, marginBottom: 5 }}
                        >
                          <Title
                            level={5}
                          >{`Períodos de ${nomeEmpreend.current} - Apartamento ${numeroApto.current}`}</Title>
                        </Flex>
                      </Col>
                    </Flex>
                  </>
                ) : null}
              </Col>
              <Col span={3} style={{ alignContent: "center" }}>
                <Button
                  type="primary"
                  onClick={() => {
                    adicionarPeriodos(false);
                  }}
                >
                  Salvar
                </Button>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col span={3}></Col>
              <Col span={18}>
                <Flex align="center" justify="center">
                  <Title
                    level={5}
                  >{`Para escolher seus períodos, transfira os períodos da esquerda para a direita e depois clique em salvar.`}</Title>
                </Flex>
              </Col>
              <Col span={3}></Col>
            </Row>
          </Row>

          <Flex
            gap="small"
            align="center"
            style={{
              width: "80%",
              height: "100%",
              overflow: "hidden",
              margin: 5,
            }}
          >
            <TableTransfer
              dataSource={mockData}
              targetKeys={targetKeys}
              disabled={disabled}
              showSearch
              showSelectAll={false}
              onChange={onChange}
              style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
                margin: 20,
              }}
              filterOption={(inputValue, item) =>
                item.periodo!.indexOf(inputValue) !== -1
              }
              leftColumns={columnsLeft}
              rightColumns={columnsRight}
            />
          </Flex>
        </Flex>
      )}
    </>
  );
}
